import { createSelector } from 'reselect'
import { Set, Map } from 'immutable'
import i18next from 'i18next'
import {
  FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_ID,
  FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_VALUE,
} from 'app/constants/favoriteActivities'
import { IFavoriteActivities } from './interface'

export const getFavoriteActivities = (state: any): IFavoriteActivities => state.get('favoriteActivities')

export const getFavoriteActivitiesList = createSelector(getFavoriteActivities, favoriteActivities =>
  favoriteActivities.get('list')
)

export const getFavoriteActivitiesPagination = createSelector(getFavoriteActivities, favoriteActivities =>
  favoriteActivities.get('pagination')
)

export const getFavoriteActivitiesPaginationPerPage = createSelector(getFavoriteActivitiesPagination, pagination =>
  pagination.get('perPage')
)

export const getFavoriteActivitiesPaginationCurrent = createSelector(getFavoriteActivitiesPagination, pagination =>
  pagination.get('current')
)

export const getFavoriteActivitiesListSize = createSelector(getFavoriteActivitiesList, list => list.size)

export const getFavoriteActivitiesTotalPages = createSelector(
  getFavoriteActivitiesListSize,
  getFavoriteActivitiesPaginationPerPage,
  (size, perPage) => Math.ceil(size / perPage)
)

export const getFavoriteActivitiesListForPage = createSelector(
  getFavoriteActivitiesList,
  getFavoriteActivitiesPaginationPerPage,
  getFavoriteActivitiesPaginationCurrent,
  (list, perPage, current) => list.slice(perPage * current, perPage * current + perPage)
)

export const getFavoriteActivitiesShowPagination = createSelector(
  getFavoriteActivitiesListSize,
  getFavoriteActivitiesPaginationPerPage,
  (size, perPage) => size > perPage
)

export const getFavoriteActivitiesLevels = createSelector(getFavoriteActivitiesList, list => {
  const filter = list.reduce(
    (acc, activity) => {
      const levelId = activity.get('levelId')
      return {
        ids: acc.ids.add(levelId),
        map: acc.map.set(levelId, `${activity.get('proTrackName')} (${activity.get('name')})`),
      }
    },
    {
      ids: Set([FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_ID]),
      map: Map({
        [FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_ID]: i18next.t(
          FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_VALUE
        ),
      }),
    }
  )
  return Map(filter)
})

export const getFavoriteActivitiesLevelsIds = createSelector(getFavoriteActivitiesLevels, levels => levels.get('ids'))

export const getFavoriteActivitiesLevelsMap = createSelector(getFavoriteActivitiesLevels, levels => levels.get('map'))

export const getFavoriteActivitiesFilter = createSelector(getFavoriteActivities, activities => activities.get('filter'))

export const getFavoriteActivitiesFilterBy = (by: any) =>
  createSelector(getFavoriteActivitiesFilter, filter => filter.get(by))

export const getFavoriteActivitiesListFiltered = createSelector(
  getFavoriteActivitiesList,
  getFavoriteActivitiesFilterBy('byProTrackLevelId'),
  (list, byProTrackLevelId) =>
    byProTrackLevelId === FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_ID
      ? list
      : list.filter(activity => activity.levelId.toString() === byProTrackLevelId)
)

export const getFavoriteActivitiesFilteredListSize = createSelector(
  getFavoriteActivitiesListFiltered,
  list => list.size
)

export const getFavoriteActivitiesFilteredTotalPages = createSelector(
  getFavoriteActivitiesFilteredListSize,
  getFavoriteActivitiesPaginationPerPage,
  (size, perPage) => Math.ceil(size / perPage)
)

export const getFavoriteActivitiesFilteredShowPagination = createSelector(
  getFavoriteActivitiesFilteredListSize,
  getFavoriteActivitiesPaginationPerPage,
  (size, perPage) => size > perPage
)

export const getFavoriteActivitiesListFilteredForPage = createSelector(
  getFavoriteActivitiesListFiltered,
  getFavoriteActivitiesPaginationPerPage,
  getFavoriteActivitiesPaginationCurrent,
  (list, perPage, current) => list.slice(perPage * current, perPage * current + perPage)
)

export const getFavoriteActivitiesPending = createSelector(getFavoriteActivities, favoriteActivities =>
  favoriteActivities.get('pending')
)

export const getFavoriteActivitiesPendingGetAll = createSelector(getFavoriteActivitiesPending, pending =>
  pending.get('getAll')
)
